import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid';
import { observer } from 'mobx-react';

interface Props {
  overviewActive: boolean;
}

function Banner({ overviewActive }: Props) {
  switch (overviewActive) {
    case false:
      return <ChevronDownIcon />;
    case true:
      return <ChevronUpIcon />;
  }
}

export default observer(Banner);
